import { memo, useCallback, useContext } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import Footer from 'components/footer/Footer';
import { FooterOkBtn } from 'components/footer/Footer.styled';
import { HiOutlineCheck } from 'react-icons/hi';
import { Step1WithQueryContetn } from './Step1.styled';
import { nextStep, prevStep } from 'store/slices/global.slice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { UserFormContext } from 'components/UserForm';

const Step1WithQuery = () => {
  const { email, phone } = useSelector((state) => state.form);
  const { setShortForm } = useContext(UserFormContext);
  const dispatch = useDispatch();

  const onYesClick = useCallback(() => {
    setShortForm(true);
    dispatch(nextStep());
  }, [dispatch, setShortForm]);

  const onNoClick = useCallback(() => {
    setShortForm(false);
    dispatch(nextStep());
  }, [dispatch, setShortForm]);

  return (
    <AnimateTop>
      <StepLayout
        title={`We have you with email ${email} and phone number ${phone}. Is this the best email and number to reach you?`}
      >
        <Step1WithQueryContetn>
          <button onClick={onYesClick}>Yes</button>
          <button onClick={onNoClick}>No</button>
        </Step1WithQueryContetn>
        <Footer
          nextArrowClick={onNoClick}
          prevArrowClick={() => dispatch(prevStep())}
        >
          <FooterOkBtn onClick={onNoClick}>
            OK <HiOutlineCheck />
          </FooterOkBtn>
        </Footer>
      </StepLayout>
    </AnimateTop>
  );
};

export default memo(Step1WithQuery);
